/**
 * This RequestHeader is used to hold the request header attributes.
*/
import { Credentials } from './credentials';
import { Consumer } from './consumer';

export class RequestHeader {
    public credentials: Credentials;
    public consumer: Consumer;
    public transactionId: string;

    constructor(credentials: Credentials, consumer: Consumer, transactionId: string) {
        this.credentials = credentials;
        this.consumer = consumer;
        this.transactionId = transactionId;
    }
}
